import { useLayoutEffect } from "react";
import styled from "styled-components";

import NavBar from "../../components/fragments/NavBar";
import { Container } from "../../components/styles/Layout";
import CreateTeamMemberForm from "../../components/fragments/CreateTeamMemberForm";

const Title = styled.h1`
    text-align: center;
    margin: 2rem;
`;

export default function CreateTeamMember() {
    useLayoutEffect(() => {
        document.getElementById("root").scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavBar location="admin" pageTitle="New Team Member" />
            <Container>
                <Title>New Team Member</Title>
                <CreateTeamMemberForm />
            </Container>
        </>
    );
}
